import React from "react";
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {
  XAxis,
  YAxis,
  Tooltip,
  Label,
  CartesianGrid,
  ResponsiveContainer,
  AreaChart,
  Area, 
  linearGradient, 
  stop, 
  defs
} from "recharts";

export default class ReportScatterChart extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      show: Array.from(props.cores)
    }
  }

  componentWillReceiveProps(nextProps){
    const { mode } = this.props;
    if(nextProps.cores && nextProps.mode === mode){
      this.setState({show: Array.from(nextProps.cores)})
    }
  }

  handleChange = event => {
    const {value, checked} = event.target;    
    let {show} = this.state;
    const {cores} = this.props;
    if (value === 'All' && checked){
      show = Array.from(cores);
    }else if (value === 'All' && !checked){
      show = [];
    }
    else if(!checked && show.includes(value)){
      const index = show.indexOf(value);
      show.splice(index, 1);
    }else if(checked && !show.includes(value)){
      show.push(value);
    }        
    this.setState({show: show}); 
  };

  render(){
    const { reports, cores, mode, colors } = this.props;
    const {show} = this.state;    

    return (
      <div>
        <Typography variant="caption" display="block" gutterBottom style={{textAlign: "right"}}>
            Servers usage.
        </Typography>
        <FormGroup row style={{marginLeft: "20%"}}>
        {
          cores.length > 0 && <FormControlLabel
            control={
              <Checkbox
                checked={cores.length === show.length}
                onChange={(e) => this.handleChange(e)}
                value="All"
                style={{color: '#000000'}}
              />
            }
          label="All"
        />
        }
        {
            cores.map(server => 
            <FormControlLabel key={server}
              control={
                <Checkbox
                  checked={show.includes(server)}
                  onChange={(e) => this.handleChange(e)}
                  value={server}
                  style={{color: colors[server]}}
                />
              }
            label={server}
          />)
          }
        </FormGroup>
        <ResponsiveContainer aspect={2.2}>
          <AreaChart 
              data={reports}
              margin={{ top: 5, right: 10, left: 10, bottom: 20 }}>
                <defs>
                  {
                    Object.keys(colors).map(core => 
                    <linearGradient id={`color${core}`} x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor={colors[core]} stopOpacity={0.8}/>
                      <stop offset="95%" stopColor={colors[core]} stopOpacity={0}/>
                    </linearGradient>)
                  }
                </defs>
              <XAxis dataKey="date">
              <Label position="bottom" style={{ textAnchor: 'middle' }}>
                  Date
              </Label>
              </XAxis>
              <YAxis>
              <Label angle={270} position='left' style={{ textAnchor: 'middle' }}>
                  {mode === "min" ? "Time (min)": "Coins"}
              </Label>
              </YAxis>
              <Tooltip />
              <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
              {
                cores.map(core =>
                  <Area type="monotone" 
                        dataKey={core}
                        hide={!show.includes(core)} 
                        stroke={colors[core]}  
                        fillOpacity={1} 
                        fill={`url(#color${core})`}/>
                )
              }
          </AreaChart>
        </ResponsiveContainer>
      </div>
    );
  }
    
}
